<template>
  <div class="top">
    <div class="top-background">
      <div class="top-header">
        <v-img v-if="isScreenSmAndDown" src="../assets/img/header-sp.png" />
        <v-img v-else src="../assets/img/header-pc.png" />
      </div>

      <div class="top-info">
        <div class="top-info-comment">
          <v-img class="top-info-heart" src="../assets/img/heart1.png" />
          <v-img class="top-info-text" src="../assets/img/top-infocoment.png" />
          <v-img class="top-info-chara" src="../assets/img/top-ayanachan.png" />
        </div>
      </div>

      <div class="top-about">
        <div class="top-about-background">
          <v-img v-if="isScreenSmAndDown" src="../assets/img/top-about-sp.png" width="100%" />
          <v-img v-else src="../assets/img/top-about-pc.png" width="100%" />
        </div>
        <v-img class="top-about-title" src="../assets/img/top-about60.png" />
        <v-img class="top-about-nonoshiri" src="../assets/img/about-text.png" />
        <v-img class="top-about-character" src="../assets/img/about-ayanachan.png" />
        <p class="top-about-text">
          あなただけの<span>罵倒少女。</span> <br />
          本当は優しくされたいのに… <br />
          厳しすぎる冷たさに、 <br />
          あなたはどうする？
        </p>
        <v-btn class="top-about-btn" large outlined rounded @click="onClickAboutMoreButton">MORE</v-btn>
      </div>
      <div class="top-character-background">
        <v-img class="top-character-title" src="../assets/img/top-character60.png" />
        <div class="top-character">
          <v-img class="top-character-round1" src="../assets/img/top-chara-round1.png" />
          <v-img class="top-character-round2" src="../assets/img/top-chara-round2.png" />
          <v-img class="top-character-text" src="../assets/img/top-chara-text.png" />
          <v-btn class="top-character-btn" large outlined rounded @click="onClickCharacterMoreButton">MORE</v-btn>
        </div>
      </div>
      <div class="top-system-background">
        <v-img class="top-system-title" src="../assets/img/top-system60.png" />
        <div class="top-system">
          <v-img class="top-system-round1" src="../assets/img/top-system-round1.png" />
          <v-img class="top-system-round2" src="../assets/img/top-system-round2.png" />
          <v-img class="top-system-text" src="../assets/img/top-system-text.png" />
          <v-img class="top-system-present" src="../assets/img/top-system-present.png" />
          <v-btn class="top-system-btn" large outlined rounded @click="onClickSystemMoreButton">MORE</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopView',
  computed: {
    isScreenSmAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    onClickAboutMoreButton() {
      this.$router.push('/about', () => {});
    },

    onClickCharacterMoreButton() {
      this.$router.push('/character', () => {});
    },

    onClickSystemMoreButton() {
      this.$router.push('/system', () => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  background: url(../assets/img/background.png) repeat-y;
  background-size: 200% auto;
  background-attachment: fixed;
  @media screen and (min-width: 960px) {
    background-size: 100% auto;
  }
  &-background {
    background-color: rgba(255, 255, 255, 0.75);
  }
  &-header {
    width: 100%;
    @media screen and (min-width: 960px) {
      margin-top: 5%;
    }
  }
  &-info {
    position: relative;
    margin: 15% 0 10%;
    width: 100%;
    @media screen and (min-width: 960px) {
      width: 70%;
      margin: 7% auto 5%;
    }
    &-comment {
      width: 90%;
      margin: 0 auto;

      @media screen and (min-width: 960px) {
        position: relative;
        padding: 30% auto 0;
        z-index: 1;
        top: 5%;
      }
    }
    &-heart {
      position: absolute;
      top: -10%;
      left: 15%;
      width: 30%;
      max-width: 300px;
      transform: rotateZ(-25deg);

      @media screen and (min-width: 960px) {
        max-width: 600px;
        top: -8%;
        left: 2%;
        transform: rotateZ(-20deg);
      }
    }
    &-text {
      margin: 0 10% 0 auto;
      width: 65%;

      @media screen and (min-width: 960px) {
        position: absolute;
        top: 20%;
        left: 14%;
        width: 53%;
        max-width: 850px;
        z-index: 1;
      }
    }
    &-chara {
      width: 70%;
      margin: 15% auto 7%;

      @media screen and (min-width: 960px) {
        width: 50%;
        max-width: 700px;
        margin: 0 0 auto auto;
      }
    }
  }

  &-about {
    position: relative;
    overflow-x: hidden;

    &-title {
      position: absolute;
      top: 5%;
      left: 3%;
      width: 57%;
      @media screen and (min-width: 960px) {
        left: 10%;
        top: 4%;
        width: 35%;
      }
    }
    &-nonoshiri {
      position: absolute;
      top: 20%;
      left: 48%;
      width: 50%;
      transform: rotateZ(17deg);
      @media screen and (min-width: 960px) {
        width: 35%;
        top: 52%;
        left: 19%;
        transform: rotateZ(0deg);
      }
    }
    &-character {
      position: absolute;
      width: 35%;
      top: 45%;
      @media screen and (min-width: 960px) {
        top: 13%;
        right: 14%;
        width: 17%;
      }
    }
    &-text {
      position: absolute;
      color: #666666;
      font: 4vw 'ヒラギノ丸ゴ Pro W4', 'ヒラギノ丸ゴ Pro', 'Hiragino Maru Gothic Pro';
      text-shadow: 2px 2px 2px #fff, -2px -2px 2px #fff, -2px 2px 2px #fff, 2px -2px 2px #fff, 2px 0px 2px #fff,
        -2px -0px 2px #fff, 0px 2px 2px #fff, 0px -2px 2px #fff;

      top: 40%;
      left: 25%;
      letter-spacing: 1px;
      line-height: 7vw;
      span {
        color: #fa60d0;
        font-weight: bold;
        font-size: 5vw;
      }
      @media screen and (min-width: 960px) {
        top: 35%;
        left: 51.5%;
        font-size: 1.5vw;
        line-height: 2.5vw;
        span {
          font-size: 2vw;
        }
      }
    }

    &-btn {
      position: absolute;
      top: 58%;
      width: 27%;
      height: 7% !important;
      left: 0;
      right: 0;
      margin: 0 auto;
      color: #ffc4ef !important;
      background: #fff;
      border: #ffc4ef 4px solid;
      border-radius: 100px;
      font-size: 6vw !important;
      font-weight: bold;
      transition: 0.3s;

      &:hover {
        color: #fff !important;
        background: #ffc4ef;
      }
      @media screen and (min-width: 960px) {
        width: 10%;
        top: 57%;
        left: 22%;
        font-size: 2vw !important;
      }
    }
  }

  &-character {
    content: '';
    position: relative;
    width: auto;
    overflow-x: hidden;
    @media screen and (min-width: 960px) {
      width: 75%;
      margin: 4% auto;
    }
    &-background {
      padding-top: 8%;
      @media screen and (min-width: 960px) {
        padding-top: 3%;
      }
    }
    &-title {
      width: 90%;
      top: 5%;
      left: 3%;
      @media screen and (min-width: 960px) {
        left: 10%;
        width: 50%;
      }
    }
    &-round1 {
      width: 68%;
      margin: 15% auto 63% -8%;
      z-index: 1;
      @media screen and (min-width: 960px) {
        margin: 6% auto 6% 18%;
        width: 32%;
      }
    }
    &-round2 {
      position: absolute;
      width: 83%;
      top: 35%;
      left: 35%;
      @media screen and (min-width: 960px) {
        top: 0%;
        left: 47%;
        width: 44%;
      }
    }
    &-text {
      position: absolute;
      width: 50%;
      top: 53%;
      left: 46%;
      @media screen and (min-width: 960px) {
        width: 23%;
        top: 31%;
        left: 58%;
      }
    }
    &-btn {
      position: absolute;
      top: 72%;
      left: 60%;
      width: 27%;
      height: 7% !important;
      color: #ffc4ef !important;
      background: #fff;
      border: #ffc4ef 4px solid;
      border-radius: 100px;
      font-size: 6vw !important;
      font-weight: bold;
      transition: 0.3s;

      &:hover {
        color: #fff !important;
        background: #ffc4ef;
      }
      @media screen and (min-width: 960px) {
        top: 64%;
        left: 60%;
        font-size: 3vw !important;
        height: 13% !important;
        border: #ffc4ef 5px solid;
        width: 20%;
      }
    }
  }
  &-system {
    position: relative;
    width: 100%;
    overflow-x: hidden;
    @media screen and (min-width: 960px) {
      width: 75%;
      margin: 3% auto 0%;
    }
    &-background {
      background: rgba(252, 234, 247, 0.7);
      padding-top: 8%;
      @media screen and (min-width: 960px) {
        padding-top: 3%;
      }
    }
    &-title {
      width: 63%;
      left: 3%;
      @media screen and (min-width: 960px) {
        left: 10%;
        width: 35%;
      }
    }
    &-round1 {
      margin: 48% auto 14% -16%;
      width: 83%;
      @media screen and (min-width: 960px) {
        margin: 0 auto 6% 17%;
        width: 44%;
      }
    }
    &-round2 {
      position: absolute;
      width: 68%;
      top: 7%;
      left: 42%;
      @media screen and (min-width: 960px) {
        width: 33%;
        top: 9%;
        left: 57%;
      }
    }
    &-text {
      position: absolute;
      width: 58%;
      top: 50%;
      right: 37%;
      @media screen and (min-width: 960px) {
        width: 30%;
        top: 25%;
        right: 46%;
      }
    }
    &-present {
      position: absolute;
      width: 23%;
      top: 70%;
      left: 47%;
      @media screen and (min-width: 960px) {
        width: 9%;
        top: 54%;
        left: 80%;
      }
    }
    &-btn {
      position: absolute;
      top: 73%;
      left: 13%;
      width: 27%;
      height: 7% !important;
      color: #ffc4ef !important;
      background: #fff;
      border: #ffc4ef 4px solid;
      border-radius: 100px;
      font-size: 6vw !important;
      font-weight: bold;
      transition: 0.3s;

      &:hover {
        color: #fff !important;
        background: #ffc4ef;
      }
      @media screen and (min-width: 960px) {
        top: 60%;
        left: 28%;
        font-size: 3vw !important;
        height: 12% !important;
        border: #ffc4ef 5px solid;
        width: 19%;
      }
    }
  }
}
</style>
